import { render } from "./VacunaProd.vue?vue&type=template&id=58d0c613&scoped=true"
import script from "./VacunaProd.vue?vue&type=script&lang=js"
export * from "./VacunaProd.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=58d0c613&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58d0c613"]])

export default __exports__